/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
/*  This form does not use a ForgeRock AM User Journey.
It populates information from a custom IDM endpoint and submits the form to a IDM endpoint
*/

import { useEffect, useState } from 'react';
import { FormContainer, MultiSelectElement, SelectElement } from 'react-hook-form-mui';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Loading from '../../02-molecules/Loading';
import FormLayout from '../../layout/form';
import FormSection from '../../01-atoms/FormSection';
import SuccessErrorModal from '../../modals/SuccessErrorModal';
import { getNameValueJsonArray } from '../../../util/uiHelper';
// import { isNil } from 'lodash';
import isNil from 'lodash/isNil';
import { BaseAlertDataInterface } from '../common/basInterface';
import { RadioButtonGroup } from 'react-hook-form-mui'
import { MessageType } from "../../modals/SuccessErrorModal";
// Store Imports
import {setRoleResourceData,setStage, setIsAlertOpen, setMessage, setMessageType,userRoleSelector, setisReqroleresourceVisited } from '../../../redux/userRolesSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import CustomFormRadioGroup from '../../../util/component/RadioGroup';
import CustomMultiSelectComponent from '../../../util/component/customMultiSelectField';
import styles from '../../../../src/styles/FormLayout.module.css';
import CustomFormContainer from '../../layout/CustomFormContainer';

interface RoleRequestSelectOrgEngineInterface {
    engineOrgData: {engineOrgMap:Map<any, any>,org:any[]},
    setChosenOrgEngineData:Function

}

export default function RoleRequestSelectOrgEngine({ engineOrgData,setChosenOrgEngineData}:RoleRequestSelectOrgEngineInterface) { 

  const formContext = useForm<{}>({
    defaultValues: {

    }
  });

  const [engineModels, setEngineModels] = useState<any[]>([]);
  const [orgs, setOrgs] = useState<any>();
  const [showEngineModels, setShowEngineModels] = useState<any>(new Map<string,any>());
  const [organizationChanged,setOrganizationChanged] = useState(false);
  const [showLoad,setShowLoad] = useState(true);
  
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { roleResourceData, stage ,isAlertOpen , message, messageType} = useAppSelector(userRoleSelector);


  //use effect hooks for setting orgnization and engine models

  useEffect(() => {
    const orgMap = new Map();
    if (!isNil(engineOrgData)) {
      const engineModels: any[] = Array.from(engineOrgData.engineOrgMap.keys());
      if (!isNil(engineModels)) {
        console.log(engineModels)
        setEngineModels(engineModels);
        setShowLoad(false)
      } else {
        setShowLoad(false)
      }
      engineOrgData.org.forEach((org:any,key:any)=>{
          orgMap.set(org._id,org)
      })
    const orgs: any[] = Array.from(orgMap.values()); 
      setOrgs(orgs)
    }
  }, [engineOrgData])


  //  ---------------------METHODS-----------------------------------
  const handleSuccess = async(data:any)=>{
        if(!showEngineModels.sem){
          data.engineModel=engineModels
        }
        dispatch(setisReqroleresourceVisited(false))
        setChosenOrgEngineData({companyId:data.organization,engineModelName:data.engineModel})

  }

  const handleOpen = () => {
    dispatch(setIsAlertOpen(true));
  };
  const handleClose = () => {
    dispatch(setIsAlertOpen(false));
  };

  const customOnChange = (value:any) => {
    console.log(value);
    if (value === 'true'){
      setShowEngineModels({"sem":true})
    } else {
      setShowEngineModels({"sem":false})
    }
  }

  

  //  -----------------END METHODS-----------------------------------

  
 

  return (
    <>

      <CustomFormContainer
        defaultValues={{}}
        formContext={formContext}
        onSuccess={handleSuccess}
      >
        <SuccessErrorModal
          open={isAlertOpen}
          type={messageType}
          handleClose={handleClose}
          message={message}
         // successMessage="Form successfully submitted"
        />
        <FormLayout
          header="new resource request"
          // subHeader="Use the form below to submit an access request to new resources. To learn more about what's available, visit the Resource Description tab.">
          // subHeader='Maecenas ac sollicitudin odio. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Suspendisse dignissim.'>
          >
          <FormSection>
            <>
            <p className={styles.subheaderText}>Use the form below to submit an access request to new resources. To learn more about what's available, visit the <a className={styles.subHeaderRoles} onClick={()=>{navigate('/roleRequest?tab=resourceDescriptions')}} >Resource Description</a> tab.</p>
                
                
                {showLoad ?
                <div style={{ marginTop: '10px', marginBottom: '40px' , border :'1px solid white'}} className="lowHeight">
                  <Loading size={100}/>
                </div>
                :
                <>
                {/* <h6>Working on engine models?</h6>
                <div style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight">
                  <CustomFormRadioGroup formContext={formContext}
                    // attributeInputCallback={attributeInputCallback}
                    name="ShowEngModels"
                    row
                    required
                    onChange={(value,) => {customOnChange(value)}}
                    options={[{value:'true',label:"Yes"},{value:'false',label:"No"}]}
                  ></CustomFormRadioGroup>
                </div> */}
              {/* {engineModels.length ? */}
              <SelectElement style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight"
                  key={'organization'}
                  id={'organization'}
                  name={'organization'}
                  label={'Company'}
                  onChange={((value)=>{
                        setOrganizationChanged(true);
                  })}
                  options={getNameValueJsonArray(orgs)}
                  required={true}
                  valueKey={'value'}
                  labelKey="name" fullWidth margin="normal" />
              {showEngineModels.sem && 
                <>
                  <div style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight">
                  <CustomMultiSelectComponent 
                    className="lowHeight multiSelectText multiselectoptions"
                    key={'engineModels'}
                    id={'engineModel'}
                    name={'engineModel'}
                    label={'Engine Models'}
                    onChange={(value) => {
                      formContext.resetField('organization' as never)
                      setOrgs(engineOrgData.engineOrgMap.get(value))
                    }}
                    options={engineModels}
                    required = {showEngineModels.sem}
                    showChips={true}
                    showCheckbox
                    // required={true}
                    fullWidth />
                  </div>
                  {/* <div style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight">
                  <a onClick={() => {
                    navigate("/myprofile?tab=personnelInfo")}
                  } style={{ textDecoration :"none"}}>
                  Missing engine models? Manage in settings.</a>
                  </div> */}

                </>
              }</>}
              {/* //    :  showLoad ?               
              //       <div style={{ marginTop: '0px', marginBottom: '40px' }} className="lowHeight">
              //         <Loading size={100}/>
              //       </div>
              // :<SelectElement style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight"
              // key={'organization'}
              // id={'organization'}
              // name={'organization'}
              // label={'Organization'}
              // onChange={((value)=>{
              //       setOrganizationChanged(true);
              // })}
              // options={getNameValueJsonArray(orgs)}
              // required={true}
              // valueKey={'value'}
              // labelKey="name" fullWidth margin="normal" /> 

              // } */}
            </>
          </FormSection>
          
        </FormLayout>
      </CustomFormContainer>

    </>
  );
};
